<template>
  <v-col align="center">
    <v-card width="1000">

      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>

      <v-card-text style="color: #4F4F4F">
        <v-row>
          <v-col align="start">
            We are sorry the Self-service Certificates product is not working out for you. Please be aware that Insureds will not be able to access any previously published certificates. Additionally, any distributed access URLS will stop functioning.
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="feedback"
              label="Feedback"
              outlined
              placeholder="Before you go, please let us know what we could've done better"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row class="mx-1">
          <v-col cols="auto">
            <v-btn
              large
              @click="returnToMarketplace"
            >
              Return to Marketplace
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-btn
              large
              :disabled="feedback == ''"
              @click="showCancelDialog=true;"
            >
              Cancel My Subscription
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

    </v-card>

    <!-- Cancellation Dialog -->
    <v-dialog
      v-model="showCancelDialog"
      width="500"
    >
      <v-card>

        <v-card-title>
          Confirm Cancellation
        </v-card-title>

        <v-card-text>
          <v-row
            dense
            justify="center"
          >
            <v-col cols="12">
              Please confirm you want to cancel access to the Self-service Certificates product.
            </v-col>
            <v-col cols="12" class="red--text">
              WARNING: Insureds will lose access to published certificates
            </v-col>

            <v-col cols="12">
              <v-alert
                v-if="error !== ''"
                class="ma-3"
                type="error"
                outlined
              >
                {{ error }}
              </v-alert>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
          <v-row dense>
            <v-col cols="auto">
              <v-btn
                @click="showCancelDialog=false"
              >
                Cancel
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-btn
                color="primary"
                @click="unsubscribe"
              >
                Confirm Cancellation
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </v-col>
</template>

<style lang="scss" scoped>
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';

export default {
  name: 'SelfServeCertsUnsubscribe',
  components: {
    ProductCardHeader
  },
  data () {
    return {
      feedback: '',
      showCancelDialog: false,
      error: ''
    };
  },
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(7);
    },
    isSubscribed () {
      var product = this.getProductByProductId(7);
      if (product) {
        return product.isSubscribed;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setProductSubscription', 'setProductTrial']),
    returnToMarketplace () {
      this.$router.push('/marketplace');
    },
    async unsubscribe () {
      // Updates API
      try {
        await this.$api.setSubscriptionDetailed(this.product.id, false, this.feedback, true);
      } catch (error) {
        this.error = 'An error has occurred, please try again shortly, or contact HawkSoft support for assistance';
        return;
      }
      // Updates local store
      this.setProductSubscription({ productId: this.product.id, subscription: false });
      // Navigates away
      this.$router.push('/product/selfServeCerts/success');
    }
  }
};
</script>
